import React, { useCallback, useMemo, memo } from 'react';

import Button from 'components/bronson/Button';
import Input from 'components/bronson/Input';

import Traductor from 'components/Traductor';
import { formatNumber } from 'js/components/shared/vehicleFunctions';

const AutoBidForm = ({
    padding,
    marginTop,
    onBid,
    disabled,
    loading,
    vehicle,
    type = '',
    inputAmount,
    onInputAmountChange,
    options,
}) => {
    const t = useMemo(() => new Traductor(), []);
    const optionsButton = {
        class: 'c-btn--full c-btn--primary-b',
        text: options?.button || t.getTraduction('BidUp'),
        btnTypes: ['secondary'],
        disabled: disabled || options?.disabledButton,
    };

    const printInputMaxBidLabel = useCallback(() => {
        if (type !== 'detailvehicle' || options?.label) return null;
        return (
            <div className={'o-layout__item u-1/1 ' + padding}>
                <p className="rema-text-overflow--ellipsis u-mb-xsmall">
                    {t.getTraduction('MaximumBid')}
                    <button
                        type="button"
                        className="c-icon c-info-icon js-tooltip c-icon--[semantic-info]"
                        data-template="maximumBidInfo"
                        style={{ fontSize: '1rem' }}
                    />
                </p>
                <div id="maximumBidInfo" style={{ display: 'none' }}>
                    <strong>{t.getTraduction('Tooltip_max_bid_title')}</strong>
                    <p>{t.getTraduction('Tooltip_max_bid_body')}</p>
                </div>
            </div>
        );
    }, [options?.label, padding, t, type]);

    const formatThousands = useCallback(value => {
        if (!value) return value;

        const resetValue = value.toString().replaceAll('.', '');

        return formatNumber(resetValue);
    }, []);

    const onChange = useCallback(
        e => {
            const value = e.target.value.replace(
                options?.inputRegex || /[^\d]/g,
                ''
            );
            return onInputAmountChange(value);
        },
        [onInputAmountChange, options?.inputRegex]
    );

    const printInputMaxBid = useCallback(() => {
        const optionsInputPuja = {
            id: 'automaticAuction' + vehicle.WebSalesId + type,
            name: 'automaticAuction' + vehicle.WebSalesId + type,
            type: 'text',
            event: true,
            disabled: loading || disabled,
            customAttributes: {
                context: 'surname',
            },
            className: 'c-input__input--blue-border',
            value: inputAmount,
            placeHolder:
                options?.label || t.getTraduction('YoutMaximumBidHere'),
        };

        return (
            <Input
                options={optionsInputPuja}
                value={formatThousands(inputAmount)}
                onChange={onChange}
                onKeyPress={onChange}
            />
        );
    }, [
        vehicle.WebSalesId,
        type,
        loading,
        disabled,
        inputAmount,
        options?.label,
        t,
        formatThousands,
        onChange,
    ]);

    return (
        <div className="o-layout">
            {printInputMaxBidLabel()}
            <div className={'o-layout__item u-2/3 u-p-none ' + marginTop}>
                {printInputMaxBid()}
            </div>
            <div className={'o-layout__item u-1/3 u-p-none ' + marginTop}>
                <Button
                    options={optionsButton}
                    onClick={() => onBid('input')}
                />
            </div>
        </div>
    );
};

export default memo(AutoBidForm);
